import { FilterTag } from './filter-tag';
import { emptySidebarStyles } from './styles';
import type { SuggestionProps } from './types';

export function SuggestionDate({ blindingFilters }: SuggestionProps) {
  const style = emptySidebarStyles();

  if (!blindingFilters.changedSinceDays.isTooRecent) {
    return null;
  }

  return (
    <div className={style.suggestion()}>
      <span>
        Increase the <FilterTag text="Changed In" /> range to reveal older
        alerts that might still require attention.
      </span>
    </div>
  );
}
